import bradescoWhite from '../images/bradesco-white.png'
import bradescoPrime from '../images/bradesco-prime.png'

import caixaWhite from '../images/caixa-white.png'

import itauGrey from '../images/itau-grey.png'
import itauPersonnalite from '../images/itau-personnalite.png'

import nubank from '../images/nubank.png'

import bb from '../images/bb.png'
import santanderWhite from '../images/santander-white.png'

export default {
  bradesco: {
    normal: {
      black: bradescoWhite,
    },
    prime: {
      black: bradescoPrime,
    },
  },
  caixa: {
    normal: {
      black: caixaWhite,
    },
  },
  itau: {
    normal: {
      black: itauGrey,
    },
    personnalite: {
      black: itauPersonnalite,
    },
  },
  nubank: {
    normal: {
      gold: nubank,
      platinum: nubank,
    },
  },
  bb: {
    ourocard: {
      black: bb,
    },
  },
  santander: {
    normal: {
      black: santanderWhite,
    },
  },
}



// WEBPACK FOOTER //
// ./components/BankLogo/helpers/bankLogos.js